import { render, staticRenderFns } from "./BadgeAndAwards_component.vue?vue&type=template&id=7e7a02ec&"
import script from "./BadgeAndAwards_component.vue?vue&type=script&lang=js&"
export * from "./BadgeAndAwards_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports